import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { idfServiceIds, ezsServiceIds } from "../../config/UserServicesList";
import { ApplicationState } from "../../store";
import { useAreServicesActive, useResourceTabPermission } from "../../util/CommonServices";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";
import { GetAccountInformation } from "../../store/service";
import { useTranslation } from "react-i18next";

const ResourcesTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const productFeatureOfBIDR = useSelector((state: ApplicationState) => state.productFeatureState?.productFeatureData);
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const [country, setCountry] = useState("");
    const partnerConfig = useSelector((state: ApplicationState) =>
        state.configurationState?.configuration.partnerConfig ? state.configurationState?.configuration.partnerConfig : null
    );
    const pcProtectionService = [idfServiceIds.onlinePcProtectionTools, ezsServiceIds.onlinePcProtectionTools];
    const isPcProtectionService = useAreServicesActive(pcProtectionService);

    const financialCoachingService = [ezsServiceIds.financialCoaching];
    const isfinancialCoachingService = useAreServicesActive(financialCoachingService);

    const supportInternational = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.supportInternational
    );
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );

    useEffect(() => {
      // state already created in index.tsx call, so use that instead of calling API again
      let currentCountry = accountInfo && accountInfo.country ? accountInfo.country :"";
      if (currentCountry) {
          setCountry(currentCountry);
      } else {
          setCountry('US');
      }
    }, []);

    let isEducationAndBreachVisible = hasEducationAndBreach;
    const showJunkAndMail = supportInternational ? country === "US" : true;
    const displaySecurityAssessment = useResourceTabPermission(productFeatureOfBIDR?.SecurityAssessmentEnabled);
    const displayCyberRiskProfile = useResourceTabPermission(productFeatureOfBIDR?.AllowWhiteHawkAssessment);
    const displayBreachReadiness = useResourceTabPermission(productFeatureOfBIDR?.BreachReadinessKitEnabled);
   

    return (
        <Tab tabId="resources-tabs">
            {isBusinessUser ? (
                <React.Fragment>
                    {displaySecurityAssessment && (
                        <TabItem title={tLang("resourcesSection.securityAssessmentTab.securityAssessmentTitle")} link="/resources/security-assessment" tabNo="1" selectedTab={props.selectedTab} />
                    )}
                    {displayCyberRiskProfile && (
                        <TabItem title="Cyber Risk Profile" link="/resources/cyber-risk-profile" tabNo="2" selectedTab={props.selectedTab} />
                    )}
                    {displayBreachReadiness && (
                        <TabItem
                            title={tLang("resourcesSection.breachReadinessSupportWidget.titleButtonText")}
                            link="/resources/breach-readiness"
                            tabNo="3"
                            selectedTab={props.selectedTab}
                        />
                    )}
                    {isEducationAndBreachVisible && i18nLang && i18nLang.language === "en" && (
                        <TabItem title="Education" link="/resources/business-education" tabNo="4" selectedTab={props.selectedTab} />
                    )}
                    {isEducationAndBreachVisible && i18nLang && i18nLang.language === "en" && (
                        <TabItem title="Breaches & Scams" link="/resources/breaches-and-scams" tabNo="5" selectedTab={props.selectedTab} />
                    )}
                    {(partnerConfig?.allowAppDownLoad || isPcProtectionService) && (
                        <TabItem title={tLang("resourcesSection.downloadsTab.tabTitle")} link="/resources/downloads" tabNo="8" selectedTab={props.selectedTab} />
                    )}
                </React.Fragment>
            ) : (
                <React.Fragment>
                    {isEducationAndBreachVisible && (
                        <TabItem
                            title={tLang("resourcesSection.resourceTabTitle.Tablabel.education")}
                            link="/resources/education"
                            tabNo="4"
                            selectedTab={props.selectedTab}
                        />
                    )}
                    {isEducationAndBreachVisible && (
                        <TabItem
                            title={tLang("resourcesSection.resourceTabTitle.Tablabel.breaches")}
                            link="/resources/breaches-and-scams"
                            tabNo="5"
                            selectedTab={props.selectedTab}
                        />
                    )}
                    {isfinancialCoachingService && (
                        <TabItem title="Financial Coaching" link="/resources/financial-coaching" tabNo="10" selectedTab={props.selectedTab} />
                    )}

                    <TabItem
                        title={tLang("resourcesSection.resourceTabTitle.Tablabel.calculators")}
                        link="/resources/calculators"
                        tabNo="6"
                        selectedTab={props.selectedTab}
                    />
                    <TabItem title={tLang("resourcesSection.resourceTabTitle.Tablabel.forms")} link="/resources/forms" tabNo="7" selectedTab={props.selectedTab} />

                    {((isPrimaryAccount && partnerConfig?.allowAppDownLoad) || isPcProtectionService) && (
                        <TabItem
                            title={tLang("resourcesSection.resourceTabTitle.Tablabel.downloads")}
                            link="/resources/downloads"
                            tabNo="8"
                            selectedTab={props.selectedTab}
                        />
                    )}
                    {showJunkAndMail && (
                        <TabItem
                            title={tLang("resourcesSection.resourceTabTitle.Tablabel.junkMail")}
                            link="/resources/junk-mail-and-calls"
                            tabNo="9"
                            selectedTab={props.selectedTab}
                        />
                    )}
                </React.Fragment>
            )}
        </Tab>
    );
};

export default ResourcesTab;
